<template>
  <div class="tabs" ref="tabbody">
    <van-tabs :ellipsis="false" v-model="active" :class="{'fixed-top':isFixed}" line-width="20" @click="handleTabClick">
      <van-tab v-for="(item,index) in floorData.navData" :title="item.label" :key="index" ></van-tab>
    </van-tabs>
  </div>
</template>

<script>

export default {
  name: 'tabs',
  props: ['floorData'],
  data() {
    return {
      active: 0,
      isFixed: false,
      tabPos: [],
      isClick: false
    }
  },
  mounted() {
    this.floorData.navData.forEach(item => {
        const pos = document.getElementById(item.value).offsetTop
        this.tabPos.push({
          id: item.value,
          pos: pos
        })
    })

    const that = this
    const floorpageDom = document.getElementById('floorpage')
    floorpageDom.addEventListener('scroll', function(e) {
      const currPos = e.target.scrollTop
      if (that.isClick) {
        return false
      }
      that.tabPos.forEach((item, index) => {
        if (currPos < that.tabPos[0].pos - 20) {
          that.isFixed = false
        } else {
          that.isFixed = true
        }
        if (index + 1 === that.tabPos.length) {
          if (currPos > item.pos) {
            that.active = index
          }
        } else {
          if (currPos > item.pos && currPos < that.tabPos[index + 1].pos) {
            that.active = index
          }
        }
      })
    })
  },
  methods: {
    handleTabClick(val) {
     /* if (val > 0) {
        this.isFixed = true
      } else {
        this.isFixed = false
      } */
      this.isClick = true
      this.isFixed = true

      const tabbody = this.$refs.tabbody
      const tabHeight = tabbody.getBoundingClientRect().height
      const id = this.floorData.navData[val].value
      const dom = document.getElementById(id)
      if (dom) {
        // let domInfo = this.$refs[refName].getBoundingClientRect()
        // const topPos = this.isFixed ? dom.offsetTop - tabHeight - 60 : 0
        const topPos = val === 0 ? dom.offsetTop - tabHeight - 80 : dom.offsetTop - tabHeight - 80
        // console.log(document.getElementById('floorpage').style, topPos)
        document.getElementById('floorpage').scrollTop = topPos
      }
      setTimeout(() => {
        this.isClick = false
      }, 500)
    }
  }
}
</script>

<style lang='scss' scoped>
.tabs{
  ::v-deep .van-tabs__nav {
    background-color: #F9F9F9;

  }

  ::v-deep .van-tab {
    font-size: 0.16rem;
    color: #333;
  }

  ::v-deep .van-tab--active {
    font-weight: 700;
  }
  ::v-deep .van-tabs--line .van-tabs__wrap{
    height: 0.6rem;
  }
}
.fixed-top{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
}
</style>
